import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../common/SideBar";
import "../../styles/global.styles.css";

const AppLayout = (props) => {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem("isUserLoggedIn") === "true";

  useEffect(() => {
    props.getLocationName(location);
  }, [location]);

  const isHome =
    location.pathname === "/" ||
    location.pathname === "/home";

  return (
    <div style={{ display: "flex", width: "100%" }}>
      {isLoggedIn &&
        location.pathname !== "/" &&
        location.pathname !== "/home" && <Sidebar />}
        <div
              style={{
                flex: 1,
                marginLeft:
                  isLoggedIn &&
                  location.pathname !== "/" &&
                  location.pathname !== "/home" &&
                  "0",
                transition: "margin-left 0.3s ease",
                width: '75%',
              }}
          >
        <Outlet />
      </div>
    </div>
  );
};

export default AppLayout;
